// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    font-family: var(--ff-primary);
    font-size: var(--fs-base);
    scroll-behavior: smooth;
    -webkit-tap-highlight-color: transparent;
}

.display-large {
    font-size: var(--fs-display-large);
    font-weight: var(--weight-regular);
    line-height: 64px;
}

.display-medium {
    font-size: var(--fs-display-medium);
    font-weight: var(--weight-regular);
    line-height: 52px;
}

.display-small {
    font-size: var(--fs-display-small);
    font-weight: var(--weight-regular);
    line-height: 44px;
}

.headline-large {
    font-size: var(--fs-headline-large);
    font-weight: var(--weight-regular);
    line-height: 40px;
}

.headline-medium {
    font-size: var(--fs-headline-medium);
    font-weight: var(--weight-regular);
    line-height: 36px;
}

.headline-small {
    font-size: var(--fs-headline-small);
    font-weight: var(--weight-regular);
    line-height: 32px;
}

.title-large {
    font-size: var(--fs-title-large);
    font-weight: var(--weight-regular);
    line-height: 28px;
}

.title-medium {
    font-size: var(--fs-title-medium);
    font-weight: var(--weight-medium);
    line-height: 24px;
}

.title-small {
    font-size: var(--fs-title-small);
    font-weight: var(--weight-medium);
    line-height: 20px;
    letter-spacing: 0.1px;
}

.label-large {
    font-size: var(--fs-label-large);
    font-weight: var(--weight-medium);
    line-height: 20px;
    letter-spacing: 0.1px;
}

.label-medium {
    font-size: var(--fs-label-medium);
    font-weight: var(--weight-medium);
    line-height: 16px;
    letter-spacing: 0.5px;
}

.label-small {
    font-size: var(--fs-label-small);
    font-weight: var(--weight-medium);
    line-height: 16px;
    letter-spacing: 0.5px;
}

.label-extra-small {
    font-size: var(--fs-label-extra-small);
    font-weight: var(--weight-medium);
    line-height: 16px;
    letter-spacing: 0.5px;
}

.body-large {
    font-size: var(--fs-body-large);
    font-weight: var(--weight-regular);
    line-height: 24px;
    letter-spacing: 0.5px;
}

.body-medium {
    font-size: var(--fs-body-medium);
    font-weight: var(--weight-regular);
    line-height: 20px;
    letter-spacing: 0.25px;
}

.body-small {
    font-size: var(--fs-body-small);
    font-weight: var(--weight-regular);
    line-height: 16px;
    letter-spacing: 0.4px;
}

.body-extra-small {
    font-size: var(--fs-body-extra-small);
    font-weight: var(--weight-regular);
    line-height: 16px;
    letter-spacing: 0.4px;
}

.list-item .text {
    color: var(--on-surface);
}

.long-text {
    font-family: var(--ff-long-text);
}
`, "",{"version":3,"sources":["webpack://./../../assets/css/typography.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,uBAAuB;IACvB,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;IAClC,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;IACjC,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;IACjC,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;IACjC,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;IACjC,iCAAiC;IACjC,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;IACjC,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;IACjC,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;IAClC,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;IAClC,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,kCAAkC;IAClC,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;AACpC","sourcesContent":["html {\n    font-family: var(--ff-primary);\n    font-size: var(--fs-base);\n    scroll-behavior: smooth;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.display-large {\n    font-size: var(--fs-display-large);\n    font-weight: var(--weight-regular);\n    line-height: 64px;\n}\n\n.display-medium {\n    font-size: var(--fs-display-medium);\n    font-weight: var(--weight-regular);\n    line-height: 52px;\n}\n\n.display-small {\n    font-size: var(--fs-display-small);\n    font-weight: var(--weight-regular);\n    line-height: 44px;\n}\n\n.headline-large {\n    font-size: var(--fs-headline-large);\n    font-weight: var(--weight-regular);\n    line-height: 40px;\n}\n\n.headline-medium {\n    font-size: var(--fs-headline-medium);\n    font-weight: var(--weight-regular);\n    line-height: 36px;\n}\n\n.headline-small {\n    font-size: var(--fs-headline-small);\n    font-weight: var(--weight-regular);\n    line-height: 32px;\n}\n\n.title-large {\n    font-size: var(--fs-title-large);\n    font-weight: var(--weight-regular);\n    line-height: 28px;\n}\n\n.title-medium {\n    font-size: var(--fs-title-medium);\n    font-weight: var(--weight-medium);\n    line-height: 24px;\n}\n\n.title-small {\n    font-size: var(--fs-title-small);\n    font-weight: var(--weight-medium);\n    line-height: 20px;\n    letter-spacing: 0.1px;\n}\n\n.label-large {\n    font-size: var(--fs-label-large);\n    font-weight: var(--weight-medium);\n    line-height: 20px;\n    letter-spacing: 0.1px;\n}\n\n.label-medium {\n    font-size: var(--fs-label-medium);\n    font-weight: var(--weight-medium);\n    line-height: 16px;\n    letter-spacing: 0.5px;\n}\n\n.label-small {\n    font-size: var(--fs-label-small);\n    font-weight: var(--weight-medium);\n    line-height: 16px;\n    letter-spacing: 0.5px;\n}\n\n.label-extra-small {\n    font-size: var(--fs-label-extra-small);\n    font-weight: var(--weight-medium);\n    line-height: 16px;\n    letter-spacing: 0.5px;\n}\n\n.body-large {\n    font-size: var(--fs-body-large);\n    font-weight: var(--weight-regular);\n    line-height: 24px;\n    letter-spacing: 0.5px;\n}\n\n.body-medium {\n    font-size: var(--fs-body-medium);\n    font-weight: var(--weight-regular);\n    line-height: 20px;\n    letter-spacing: 0.25px;\n}\n\n.body-small {\n    font-size: var(--fs-body-small);\n    font-weight: var(--weight-regular);\n    line-height: 16px;\n    letter-spacing: 0.4px;\n}\n\n.body-extra-small {\n    font-size: var(--fs-body-extra-small);\n    font-weight: var(--weight-regular);\n    line-height: 16px;\n    letter-spacing: 0.4px;\n}\n\n.list-item .text {\n    color: var(--on-surface);\n}\n\n.long-text {\n    font-family: var(--ff-long-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
